function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBadgeCaretDown = function SvgIconBadgeCaretDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.996,
    r: 11.5,
    stroke: props.color
  }), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "m7 10.663 5 5 5-5"
  }));
};
export default SvgIconBadgeCaretDown;